export enum GuestStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  DECLINED = 'declined',
  MAYBE = 'maybe',
  INVITED = 'invited',
  NOT_INVITED = 'not_invited'
}

export enum GuestCategory {
  BRIDE_GROOM = 'bride_groom',
  FAMILY_CLOSE = 'family_close',
  FAMILY_EXTENDED = 'family_extended',
  WITNESS = 'witness',
  HONOR_PARTY = 'honor_party',
  FRIEND_CLOSE = 'friend_close',
  FRIEND = 'friend',
  COLLEAGUE = 'colleague',
  ACQUAINTANCE = 'acquaintance',
  OTHER = 'other'
}

export enum GuestRelation {
  PARENT = 'parent',
  SIBLING = 'sibling',
  SIBLING_SPOUSE = 'sibling_spouse',
  GRANDPARENT = 'grandparent',
  WITNESS = 'witness',
  WITNESS_SPOUSE = 'witness_spouse',
  BRIDESMAID = 'bridesmaid',
  GROOMSMAN = 'groomsman',
  CHILD_ATTENDANT = 'child_attendant',
  UNCLE_AUNT = 'uncle_aunt',
  COUSIN = 'cousin',
  DISTANT_RELATIVE = 'distant_relative',
  CHILDHOOD_FRIEND = 'childhood_friend',
  SCHOOL_FRIEND = 'school_friend',
  COMMON_FRIEND = 'common_friend',
  COLLEAGUE = 'colleague',
  BOSS = 'boss',
  BUSINESS_RELATION = 'business_relation',
  CLUB_FRIEND = 'club_friend',
  NEIGHBOR = 'neighbor',
  RELIGIOUS_COMMUNITY = 'religious_community',
  OTHER = 'other'
}

export enum GuestSide {
  BRIDE = 'bride',
  GROOM = 'groom',
  BOTH = 'both',
  NONE = 'none'
}

export type AgeGroup = 'child' | 'teen' | 'adult' | 'senior';

export interface GuestFilters {
  status?: GuestStatus[];
  category?: GuestCategory[];
  side?: GuestSide[];
  relation?: GuestRelation[];
  ageGroup?: AgeGroup[];
  vip?: boolean;
  search?: string;
}

export interface GuestStats {
  total: number;
  confirmed: number;
  declined: number;
  pending: number;
  maybe: number;
  invited: number;
  notInvited: number;
  adults: number;
  children: number;
  teens: number;
  seniors: number;
}

export interface Guest {
  id: string;
  weddingId: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  status: GuestStatus;
  ageGroup: AgeGroup;
  category?: GuestCategory;
  side?: GuestSide;
  relation?: GuestRelation;
  group?: string;
  vip?: boolean;
  dietaryRestrictions?: string[];
  notes?: string;
  rsvpNotes?: string;
  createdAt: Date;
  updatedAt?: Date;
  tableNumber?: number;
  plusOne: boolean;
  plusOneId?: string;
  plusOneName?: string;
  childrenCount?: {
    children: number;
    teens: number;
  };
  conflicts?: string[];
  mustBeWith?: string[];
  specialNeeds?: string;
  createdBy?: {
    id: string;
    type: string;
    email?: string;
    accessLevel?: string;
  };
  lastModifiedBy?: {
    id: string;
    type: string;
    email?: string;
    accessLevel?: string;
  };
  isVirtual?: boolean; // Indique si c'est un invité virtuel (enfant/ado accompagnant)
  parentGuestId?: string; // ID de l'invité parent si c'est un invité virtuel
} 